// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 64 64"
    {...props}
  >
    <circle
      cx={32}
      cy={32}
      r={31.25}
      fill="url(#a)"
      stroke="url(#b)"
      strokeWidth={1.5}
    />
    <defs>
      <linearGradient
        id="a"
        x1={32}
        x2={32}
        y1={0}
        y2={64}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAF1E8" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={32}
        x2={32}
        y1={0}
        y2={64}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFD3B8" />
        <stop offset={0.818} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
const IconEllipseShade = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconEllipseShade;
